const styles = (theme) => ({
  radioRoot: {
    color: "#ffffff",
    padding: "0 9px",
    "&$checked": {
      color: "#B231B9",
    },
    "&$disabled": {
      color: "#ffffff",
    },
    "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)": {
      stroke: ({ isDark }) => (isDark ? "#ffffff" : "#000000"),
      fontSize: 18,
      strokeWidth: 2,
      [theme.breakpoints.down("md")]: {
        fontSize: 16,
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: 17,
        strokeWidth: 2,
      },
    },
    "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
      fontSize: 18,
      [theme.breakpoints.down("md")]: {
        fontSize: 16,
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: 17,
        strokeWidth: 2,
      },
    },
  },
  sourceClass: {
    fontWeight: "800",
    fontStyle: "normal",
    fontSize: "1.7rem",
    fontFamily: "ProximaNova",
    lineHeight: "41px",
    textAlign: "left",
    marginBottom: "10px",
    marginLeft: "33px",
    [theme.breakpoints.down("md")]: {
      fontSize: "1.4rem",
      lineHeight: "1.3",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "26px",
      lineHeight: "31px",
      textAlign: "left",
      marginLeft: "0",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "18px",
      lineHeight: "1",
      marginBottom: "20px",
      marginLeft: "0",
    },
  },
  assetClass: {
    fontWeight: "800",
    fontStyle: "normal",
    fontSize: "1.7rem",
    fontFamily: "ProximaNova",
    lineHeight: "41px",
    textAlign: "left",
    marginBottom: "10px",
    [theme.breakpoints.down("md")]: {
      fontSize: "1.4rem",
      lineHeight: "1.3",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "26px",
      lineHeight: "31px",
      marginTop: "20px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "18px",
      lineHeight: "1",
      marginBottom: "20px",
      marginTop: "5px",
    },
  },
  label: {
    "&$disabled": {
      color: "#767476",
    },
  },
  gridItem: {
    textAlign: "left",
    paddingLeft: "8.4%",
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: 0,
      marginBottom: "20px",
    },
    [theme.breakpoints.down("xs")]: {
      textAlign: "left",
    },
  },
  gridItemAsset: {
    textAlign: "left",
    paddingLeft: "5%",
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: 0,
    },
    [theme.breakpoints.down("xs")]: {
      textAlign: "left",
    },
  },
  checked: {},
  disabled: {},
  grid: {
    width: "calc(100% + 50px)",
    margin: "10px -25px",
    display: "flex",
    flexWrap: "nowrap",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      margin: "20px 0 10px",
      flexWrap: "wrap",
      paddingLeft: "7%",
    },
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "4%",
    },
  },
  chainTypo: {
    fontFamily: "Barlow",
    fontWeight: "400",
    fontStyle: "normal",
    fontSize: "20px",
    lineHeight: "1",
    marginTop: "-2px",
    [theme.breakpoints.down("md")]: {},
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px",
      lineHeight: "26px",
      marginTop: "-3px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "17px",
      lineHeight: 1,
      marginTop: 0,
    },
  },
  assetTypo: {
    fontFamily: "Barlow",
    fontWeight: "400",
    fontStyle: "normal",
    fontSize: "20px",
    lineHeight: "1",
    marginTop: "-5px",
    [theme.breakpoints.down("md")]: {
      flexWrap: "wrap",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "24px",
      lineHeight: "29px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "15px",
      lineHeight: "1.4",
    },
  },
  assetText: {
    [theme.breakpoints.down("xs")]: {
      fontSize: "5px",
    },
  },
  formControl: {
    marginTop: "12px",
    paddingBottom: "16px",
    alignItems: "flex-start",
    /* [theme.breakpoints.down("md")]: {
      marginTop: "20px",
    }, */
    [theme.breakpoints.down("sm")]: {
      /* marginTop: "20px", */
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "0",
      marginRight: "0",
    },
  },
  gridFielset: {
    //marginTop: "15px",
    marginLeft: "35px",
    /* [theme.breakpoints.down("md")]: {
      marginTop: "0px",
      marginLeft: "0px",
    }, */
    [theme.breakpoints.down("sm")]: {
      marginTop: "0px",
      marginLeft: "0px",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "0px",
      marginLeft: "0px",
    },
  },
  gridFielsetAsset: {
    //marginTop: "15px",
    marginLeft: "10px",
    [theme.breakpoints.down("md")]: {
      marginTop: "0px",
      marginLeft: "0px",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "0px",
      marginLeft: "0px",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "0px",
      marginLeft: "0px",
    },
  },
  image: {
    height: 19,
    marginTop: 0,
    zIndex: 2,
    [theme.breakpoints.down("md")]: {
      width: 19,
      height: 19,
    },
    [theme.breakpoints.down("sm")]: {
      width: 19,
      height: 19,
    },
    [theme.breakpoints.down("xs")]: {
      width: "auto",
      height: 17,
    },
  },
  widgetButton: {
    height: "35px",
    fontSize: "14px",
    width: "335px",
    color: "white",
    position: "relative",
    border: "1px solid rgba(231, 206, 74, 0.21)",
    background: ({ isDark }) =>
      isDark
        ? "linear-gradient(90deg, rgba(100, 231, 239, 1) 0%, rgba(142, 62, 204, 1) 50%, rgba(92, 221, 239, 1) 100%) !important"
        : "linear-gradient(90deg, #7DB9F1 0%, #C798EC 50%, #7DB9F1 100%) !important",
    backdropFilter: "blur(21px)",
    "&:hover": {
      background:
        "linear-gradient(90deg,  rgba(68, 215, 226, 1) 0%,  rgba(132, 33, 159, 1) 50%, rgba(68, 215, 226, 1) 100%) !important",
    },
    [theme.breakpoints.down("md")]: {
      marginTop: "2%",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "8%",
    },
    [theme.breakpoints.down("xs")]: {
      height: "23px",
      width: "165px",
      fontSize: "8px",
      marginTop: "-35px",
    },
  },
});

export default styles;
